import ApiConfig from "../config";

export const QUESTIONS_GETALL = "QUESTIONS_GETALL";
export const ANSWER_ADD = "ANSWER_ADD";
export const ANSWER_REMOVE = "ANSWER_REMOVE";
export const SUBMIT_FORM = "SUBMIT_FORM";

function _getAllQuestions(res) {
  return { type: QUESTIONS_GETALL, payload: res };
}

export function getAllQuestions() {
  return (dispatch) => {
    return $.ajax({
      url: ApiConfig.ApiUrl + "GetAllQuestionsWithAnswers",
      type: "GET",
    }).done((res) => {
      dispatch(_getAllQuestions(res));
    });
  };
}

export function addAnswer(item) {
  return { type: ANSWER_ADD, payload: item };
}
export function removeAnswer(item) {
  return { type: ANSWER_REMOVE, payload: item };
}

export function submitForm(formData) {

  return () => {
    return $.ajax({
      url: ApiConfig.ApiUrl + "Submit",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify(formData),
      success: (res) => {
        return res;
      },
    });
  };
}
export function addOffer(data,formId) {
  var offer = {OfferText: data,Formid : formId};
  return () => {
    return $.ajax({
      url: ApiConfig.ApiUrl + "AddOffer",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify(offer),
      success: (res) => {
        return res;
      },
    });
  };
}


// WEBPACK FOOTER //
// ./src/Actions/a.survey.js